// extracted by mini-css-extract-plugin
export default {"positive":"BalanceCell_positive__0ugm8","negative":"BalanceCell_negative__vMJW2"};